module.exports = __webpack_public_path__ + "static/media/thankyou.c55e52ed.jpg";